import React, { useState } from 'react'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Calendar } from '@/Components/ui/calendar'
import { ScrollArea, ScrollBar } from '@/Components/ui/scroll-area'
import { Button } from '@/Components/ui/button'
import Constant from '@/utils/Constant'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
const DateTimePicker = ({ value, handleChanges, className }) => {
    const [dateTime, setDateTime] = useState(value ? new Date(value) : '')
    function handleDateSelect(date) {
        if (date) {
            setDateTime(date)
            handleChanges(date)
        }
    }
 
    function handleTimeChange(type, value) {
        console.log('in handletime', type, value)
        let newDate = new Date(dateTime)
        if (type === 'hour') {
            const hour = parseInt(value, 10)
            newDate.setHours(newDate.getHours() >= 12 ? hour + 12 : hour)
        } else if (type === 'minute') {
            newDate.setMinutes(parseInt(value, 10))
        } else if (type === 'ampm') {
            const hours = newDate.getHours()
            if (value === 'AM' && hours >= 12) {
                newDate.setHours(hours - 12)
            } else if (value === 'PM' && hours < 12) {
                newDate.setHours(hours + 12)
            }
        }
        setDateTime(newDate)
        handleChanges(newDate)
    }
    return (
        <Popover>
            <PopoverTrigger asChild>
                <FormControl>
                    <Button variant={'outline'} className={cn('w-full pl-3 py-6 text-left font-normal', !dateTime && 'text-muted-foreground' , className)}>
                        {dateTime ? format(dateTime, 'MM/dd/yyyy hh:mm aa') : null}
                    </Button>
                </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <div className="sm:flex">
                    <Calendar mode="single" selected={dateTime} onSelect={handleDateSelect} initialFocus />
                    <div className="flex flex-col sm:flex-row sm:h-[300px] divide-y sm:divide-y-0 sm:divide-x max-h-[225px]">
                        <ScrollArea className="w-64 sm:w-auto">
                            <div className="flex sm:flex-col p-2">
                                {Array.from({ length: 12 }, (_, i) => i + 1)
                                    .reverse()
                                    .map((hour) => (
                                        <Button
                                            key={hour}
                                            size="icon"
                                            variant={dateTime && dateTime.getHours() % 12 === hour % 12 ? 'default' : 'ghost'}
                                            className="sm:w-full shrink-0 aspect-square"
                                            onClick={() => handleTimeChange('hour', hour.toString())}
                                        >
                                            {hour}
                                        </Button>
                                    ))}
                            </div>
                            <ScrollBar orientation="horizontal" className="sm:hidden" />
                        </ScrollArea>
                        <ScrollArea className="w-64 sm:w-auto">
                            <div className="flex sm:flex-col p-2">
                                {Array.from({ length: 12 }, (_, i) => i * 5).map((minute) => (
                                    <Button
                                        key={minute}
                                        size="icon"
                                        variant={dateTime && dateTime.getMinutes() === minute ? 'default' : 'ghost'}
                                        className="sm:w-full shrink-0 aspect-square"
                                        onClick={() => handleTimeChange('minute', minute.toString())}
                                    >
                                        {minute.toString().padStart(2, '0')}
                                    </Button>
                                ))}
                            </div>
                            <ScrollBar orientation="horizontal" className="sm:hidden" />
                        </ScrollArea>
                        <ScrollArea className="">
                            <div className="flex sm:flex-col p-2">
                                {['AM', 'PM'].map((ampm) => (
                                    <Button
                                        key={ampm}
                                        size="icon"
                                        variant={
                                            dateTime &&
                                            ((ampm === 'AM' && dateTime.getHours() < 12) || (ampm === 'PM' && dateTime && dateTime.getHours() >= 12))
                                                ? 'default'
                                                : 'ghost'
                                        }
                                        className="sm:w-full shrink-0 aspect-square"
                                        onClick={() => handleTimeChange('ampm', ampm)}
                                    >
                                        {ampm}
                                    </Button>
                                ))}
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    )
}
 
export default DateTimePicker